module.exports = __webpack_public_path__ + "static/img/静止.9e67887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/中巴/静止.png
// module id = rO1q
// module chunks = 76